<template>
  <div class="mx-6">
    <h2 style="margin-top: 93px; font-size: 37px">Editar Disparos de SMS</h2>
    <p>Área voltada para o envio de SMS</p>

    <v-card width="846" height="137" class="pa-8 mb-6 mt-9">
      <h4>Canal de envio</h4>

      <v-radio-group
        row
        class="mt-7 d-flex align-center"
        v-model="item.channelType"
      >
        <v-radio class="" type="radio" :value="mo_engage" />
        <label class="mr-6">Push - MoEngage (App)</label>
        <v-radio disabled class="" type="radio" :value="mkt_cloud" />
        <label class="mr-6">Push - MktCloud (Web)</label>
        <v-radio disabled class="" type="radio" :value="mkt_cloudSMS" />
        <label class="mr-6">Push+SMS - MktCloud</label>
        <v-radio disabled class="" type="radio" :value="sms" />
        <label class="mr-6">SMS - MktCloud</label>
      </v-radio-group>
    </v-card>

    <div class="d-flex flex-row">
      <v-card width="405" height="665" class="mr-4 pa-8 d-flex flex-column">
        <div class="d-flex flex-column mr-8">
          <label class="font-weight-black" style="font-size: 14px">Nome</label>
          <input
            v-model="item.name"
            type="text"
            class="pl-2 mt-3"
            style="
              border: 2px solid var(--grey-day-020);
              height: 48px;
              width: 341px;
            "
          />
        </div>
        <div class="d-flex flex-column">
          <label class="font-weight-black mt-7" style="font-size: 14px"
            >Titulo</label
          >
          <input
            v-model="item.title"
            type="text"
            class="input-fields pl-2 mt-3"
            style="
              border: 2px solid var(--grey-day-020);
              height: 48px;
              width: 341px;
            "
          />
        </div>
        <div class="d-flex flex-column mt-7">
          <label class="font-weight-black" style="font-size: 14px"
            >Mensagem<span style="font-size: 12px; color: var(--grey)">
              {{ item.message.length }}/200</span
            ></label
          >
          <textarea
            v-model="item.message"
            outlined
            height="192px"
            class="rounded mt-3"
            rows="8"
            :maxlength="200"
            placeholder="Texto da mensagem"
            style="border: 2px solid var(--grey-day-020)"
          ></textarea>
        </div>
      </v-card>
      <v-card width="405" height="665" class="pa-8">
        <div class="d-flex flex-column mr-8">
          <label class="font-weight-black" style="font-size: 20px"
            >Área de testes</label
          >
          <p class="mt-2" style="font-size: 16px">
            Antes de disparar os SMS faça o teste com o seu smartphone
          </p>
          <p class="mt-8" style="font-weight: 700; font-size: 14px">
            Visualização (sem acentuação para SMS)
          </p>
          <textarea
            v-model="item.message"
            style="
              border: 2px solid var(--grey-day-020);
              width: 341px;
              height: 192px;
              background: var(--grey-day-010);
            "
          >
          </textarea>
        </div>
        <v-btn
          width="341"
          height="56"
          color="var(--red)"
          class="mt-7 mb-8"
          disabled
        >
          Enviar Teste por SMS
          <img class="ml-5" src="../../../../static/images/send_grey.svg" />
        </v-btn>
        <span class="font-weight-black" style="font-size: 20px"
          >Aparelho cadastrado</span
        >
        <p class="mt-2" style="font-size: 16px">
          O teste realizado será enviado para o seu telefone previamente
          cadastrado em nosso sistema
        </p>
      </v-card>
    </div>

    <v-card
      class="mt-6 pa-8"
      style="
        width: 826px;
        height: 200px;
        background: var(--white);
        border-radius: 4px;
      "
    >
      <h2 style="font-size: 27px">Agendamento</h2>
      <p class="mt-2">Escolha data e hora para que o envio do SMS</p>
      <div class="mt-5">
        <date-picker
          v-model="date"
          value-type="date"
          placeholder="00/00/0000"
          class="mr-5"
        ></date-picker>
        <span class="font-weight-black">Horário</span>
        <date-picker
          v-model="hour"
          format="hh:mm a"
          value-type="format"
          type="time"
          placeholder="00:00"
        ></date-picker>
      </div>
    </v-card>

    <div class="mt-14" style="height: 100px">
      <span style="font-size: 22px; font-weight: bold"
        >Informações Adicionais da Mensagem</span
      >
      <v-card class="pa-8 mb-12 mt-8" width="826" height="800">
        <div class="format-url pa-6">
          <p>Url</p>
          <div class="d-flex flex-row align-center">
            <input
              v-model="item.moeCampaignName"
              class="pl-2 mr-2"
              placeholder="Nome da campanha"
              style="
                border: 2px solid var(--grey-day-030);
                border-radius: 4px;
                height: 48px;
                width: 446px;
                background: var(--white);
              "
            />
            <v-btn
              width="258"
              height="48"
              color="var(--red)"
              dark
              class="d-flex align-center"
              style="font-size: 12px"
            >
              <img src="../../../../static/images/mic.svg" />
              Formatar Url para Podcast
            </v-btn>
          </div>
        </div>

        <div class="mt-3 d-flex align-center">
          <img src="../../../../static/images/warning.svg" />
          <span class="ml-4 mt-1" style="font-size: 13px"
            >Utilizar esse campo em mensagens SMS pode quebrar o link em duas
            mensagens e o link acabar invalidado.</span
          >
        </div>

        <div class="d-flex flex-column">
          <span class="font-weight-black mt-5"> Tipo </span>
          <v-select
            v-model="type"
            placeholder="Simples (sem link)"
            class="mt-3 rounded"
            style="border: 2px solid var(--grey-day-020)"
            :options="listTypes"
          />
          <span class="font-weight-black mt-5"> Listas </span>
          <textarea
            v-model="item.list"
            outlined
            rows="10"
            maxlength="127"
            class="rounded mt-3"
            style="border: 2px solid var(--grey-day-020)"
          ></textarea>
        </div>

        <div class="d-flex flex-row align-center mt-2">
          <span class="font-weight-black mb-0 mr-5"> Tipo do Push </span>
          <v-switch v-model="item.pushType" color="var(--blue)" inset></v-switch>
          <span> feed</span>
        </div>
        <span class="font-weight-black mt-2"> Slug do produto </span>
        <v-select
          v-model="item.produtoSlug"
          placeholder="Simples (sem link)"
          class="rounded mt-3"
          style="border: 2px solid var(--grey-day-020)"
          :options="lists"
        />
      </v-card>

      <div
        style="height: 100px; width: 826px; background: var(--grey-day-060)"
        class="rounded d-flex align-center pa-8 justify-space-between mt-8"
      >
        <span style="color: var(--white); width: 450px"
          >Este disparo estará disponível dentro de Agendamentos. Se necessário
          poderá ser alterado ou cancelado.</span
        >
        <v-btn color="var(--red)" height="50" @click="submit">
          <img class="mr-2" src="../../../../static/images/edit_white.svg" />
          <span style="color: var(--white)">Salvar Alterações</span>
        </v-btn>
      </div>
      <div style="height: 35px"></div>
    </div>
  </div>
</template>
<script>
// Libs
import { mapState, mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import StringHelper from "@/helpers/string";

import VueCookies from 'vue-cookies'

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      message: "",
      hour: "",
      date: "",
      channelType: "",
      mo_engage: "PUSH_MOE",
      mkt_cloud: "PUSH",
      mkt_cloudSMS: "PUSH_SMS",
      sms: "SMS",
      lists: [],
      type: '',
      listTypes: [
        'Simples (sem link)',
        'Link para conteúdo interno',
        'Link para conteúdo externo'
      ],
    };
  },
  computed: {
    ...mapState("Logs", {
      item: "logsToEdit",
    }),
  },
  methods: {
    ...mapActions("Logs", {
      updateMessage: "updateMessage",
    }),
    async submit() {
      const token = VueCookies.get('jwt-login')
      await this.handleUpdate(token);
    },
    async handleUpdate(token) {
      try {
        const response = await this.updateMessage([
          {
            ...this.item,
            channelType: this.item.channelType,
            list: this.item.list,
            message: this.item.message,
            messageType: this.item.messageType,
            moeCampaignName: this.item.moeCampaignName,
            name: this.item.name,
            produtoSlug: this.item.produtoSlug,
            pushType: this.item.pushType,
            sendTime: this.item.sendTime,
            smsContent: this.item.smsContent,
            title: this.item.title,
            url: this.item.url,
          },
          token,
        ]);
        // if (!JSON.parse(this.item.copy_is_active)) {
        //   await this.disableCopy([
        //     this.item,
        //     token
        //   ])
        // }
        if (response.status >= 400) {
          throw new Error(response.data.message);
        } else {
          // this.toaster(
          //   'Copy atualizado com sucesso',
          //   'success',
          //   true
          // )
        }
        // this.closeForm()
      } catch (e) {
        // this.toaster(e.message, 'danger', true)
      }
    },
  },
  watch: {
    message() {
      this.message = StringHelper.removeSpecialCharacters(
        this.item.communication_text.split("–").join("-")
      );
    },
  },
};
</script>
<style lang="" scoped>
label {
  font-size: 12px;
  margin-right: 62px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 10px;
}

.v-radio-group {
  display: flex;
  align-items: center;
}

.format-url {
  background: var(--grey-day-060);
  border-radius: 4px;
  color: var(--white);
  width: 762px;
  height: 128px;
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/EditPush.vue